// extracted by mini-css-extract-plugin
export default {"cls1":"RelatedPapers-cls1__cK","cls2":"RelatedPapers-cls2_Miv RelatedPapers-cls1__cK"};